import {mapGetters} from 'vuex';

const prakerjaClosestCourses = {
  data() {
    return {
      courseTypeValue: {
        value: 'all_course',
        name: 'Semua tipe kelas',
      },
      timeFrameValue: {
        value: 'all_time',
        name: 'Semua waktu',
      },
    };
  },
  mounted() {
    this.$store.dispatch('sections/fetchClosestCourses', {
      params: {
        course_type: this.courseTypeValue.value,
        course_timeframe: this.timeFrameValue.value,
      },
    });
  },
  watch: {
    'courseTypeValue.value'(newValue) {
      this.$store.dispatch('sections/fetchClosestCourses', {
        params: {
          course_type: newValue,
          course_timeframe: this.timeFrameValue.value,
        },
      });
    },
    'timeFrameValue.value'(newValue) {
      this.$store.dispatch('sections/fetchClosestCourses', {
        params: {
          course_type: this.courseTypeValue.value,
          course_timeframe: newValue,
        },
      });
    },
  },
  computed: {
    ...mapGetters(['isLoadingClosestCourses']),
    ...mapGetters('sections', ['getClosestCoursesConfig', 'getClosestCourses', 'getClosestTimestamp']),
    courseType() {
      return this.getClosestCoursesConfig?.courseType || [];
    },
    timeFrame() {
      return this.getClosestCoursesConfig?.timeFrame || [];
    },
    displayFirstTenCourses() {
      return this.getClosestCourses?.slice(0, 10) || [];
    },
    closestDate() {
      const closestTimestamp = new Date(this.getClosestTimestamp);
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      const options = {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      };

      return this.getClosestCourses.length > 0
        ? closestTimestamp.toLocaleDateString('id-ID', options)
        : tomorrow.toLocaleDateString('id-ID', options);
    },
    isShowLihatSemua() {
      return this.getClosestCourses?.length > 10 && !this.isLoadingClosestCourses;
    },
    isEmptyClass() {
      return this.displayFirstTenCourses?.length === 0;
    },
  },
  methods: {
    serializeItemToCourse(item) {
      return {
        id: item.item_id,
        name: item.item_name,
        images: [{url: item.image_url}],
        discount: {original_price: item.original_price},
        rating: item.rating,
        courseType: item.course_type || '',
        prakerja_remaining_stock: item.prakerja_remaining_stock,
      };
    },
    redirectLink() {
      return `kelas-terdekat?course_type=${this.courseTypeValue.value}&time_frame=${this.timeFrameValue.value}`;
    },
  },
};

export default prakerjaClosestCourses;
